// AUTO-GENERATED by scripts/prepare-brand.mjs — do not edit
import FAQSection from './faqsection'
export default FAQSection
